export const EXPIRAITON_SETTINGS_QUERY = `
  rentalHouse
  expirationDays
  enabled
`;
